<template>
  <div class="pt-4">
    <AttachDocumentSingle
      :load-profile-document-type="DocumentType.FILE"
      :value="{
        file: v.file.$model,
        fileSig: v.fileSig.$model,
      }"
      :error-messages="getValidationErrorText(v.file)"
      @change="
        v.file.$model = $event.file;
        v.fileSig.$model = $event.fileSig;
      "
      @change-from-profile="
        v.description.$model = $event.description;
        v.file.$model = $event.file;
        v.fileSig.$model = $event.fileSig;
      "
    />
    <v-textarea
      v-if="hasDescription"
      v-model.trim="v.description.$model"
      :errorMessages="getValidationErrorText(v.description)"
      outlined
      label="Описание (при наличии)"
    />
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import { DocumentType } from '@/types/services';

export default {
  name: 'Document',
  components: {
    AttachDocumentSingle,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    hasDescription: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    DocumentType,
    getValidationErrorText,
  }),
};
</script>
